module.exports = "https://img1.zhuanstatic.com/platform/zz-universal-pages/static/img/auth_success.52a8019a.png";